/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilitiesTrendListFiltersSortCriteria {
    getFixupPrototypeFunction() { return InfraVulnerabilitiesTrendListFiltersSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilitiesTrendListFiltersSortCriteria>): InfraVulnerabilitiesTrendListFiltersSortCriteria {
        let obj = Object.assign(new InfraVulnerabilitiesTrendListFiltersSortCriteria(), model);
        InfraVulnerabilitiesTrendListFiltersSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilitiesTrendListFiltersSortCriteria>): InfraVulnerabilitiesTrendListFiltersSortCriteria {
        if (!model) return null;
        return InfraVulnerabilitiesTrendListFiltersSortCriteria.newInstance(<InfraVulnerabilitiesTrendListFiltersSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilitiesTrendListFiltersSortCriteria) {
        if (!obj) return;

        models.InfraVulnerabilitiesTrendListFiltersSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilitiesTrendListFiltersSortCriteria): boolean {
        Object.setPrototypeOf(obj, InfraVulnerabilitiesTrendListFiltersSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.InfraVulnerabilitiesTrendListFiltersSortColumn;

    ascending: boolean;

}
